module.exports = __webpack_public_path__ + "static/media/196-tajikistan.8a09701f.svg";